import React from 'react';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import { CiSearch } from 'react-icons/ci';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  const intl = useIntl();

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <CiSearch className={css.searchIcon} />

      <span className={css.noResultText}>{intl.formatMessage({ id: 'SearchPage.noResults' })}</span>

      <span className={css.noResultDesc}>
        {intl.formatMessage({ id: 'SearchPage.noResultsDesc' })}
      </span>
      <br />
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFilters'} />
        </button>
      ) : null}
      {/* <p>{createListingLinkMaybe}</p> */}
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
